import React, { useEffect, useState } from "react";
import MaterialTabView from "./MaterialTabView";
import { QuarryProfileConsts } from "./constants";
import ThreeComponentLayout from "../../../reusable-components/ThreeComponentLayout";
import QuarryDetailsCard from "./QuarryDetailsCard";
import QuarryFinanceCard from "./QuarryFinanceCard";
import DatabaseTab from "../../DatabaseTab";
import { DatabaseSections } from "../../../enums/DatabaseEnums";
import { useLocation } from "react-router-dom";
import QuarryDatabaseService from "../../../services/quarryDatabase.service";
import NonEditableMask from "../../../reusable-components/NonEditableMask";

const QuarryProfile = () => {
  const location = useLocation();
  const pathCustomerId = location.pathname.split("/")[3];
  const [isMasked, setIsMasked] = useState(location.state?.applyMask || false);

  const prependTabs: CustomTab[] = [
    {
      key: QuarryProfileConsts.TAB_KEY,
      label: QuarryProfileConsts.TAB_LABEL,
      children: (
        <MaterialTabView
          sectionKey={DatabaseSections?.QUARRY}
          quarryId={pathCustomerId}
        />
      ),
    },
  ];

  const { FetchQuarryHeaderDetails } = QuarryDatabaseService();
  const { data, refetch } = FetchQuarryHeaderDetails({
    quarryId: pathCustomerId,
  });

  useEffect(() => {
    refetch();
  }, [pathCustomerId]);

  return (
    <>
      <NonEditableMask isMasked={isMasked} />
      <ThreeComponentLayout
        topLeftWidthPercent={70}
        topLeft={<QuarryDetailsCard quarryDetails={data} />}
        topRight={<QuarryFinanceCard quarryDetails={data} />}
        bottom={
          <DatabaseTab
            section={DatabaseSections?.QUARRY}
            sectionId={pathCustomerId}
            isQuarry={true}
            prependTabs={prependTabs}
          />
        }
      />
    </>
  );
};

export default QuarryProfile;
